import { render } from "./AboutUS.vue?vue&type=template&id=71775138&scoped=true"
import script from "./AboutUS.vue?vue&type=script&steup=true&lang=js"
export * from "./AboutUS.vue?vue&type=script&steup=true&lang=js"

import "./AboutUS.vue?vue&type=style&index=0&id=71775138&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71775138"]])

export default __exports__